"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Red = exports.Whatsapp = exports.Vk = exports.Vimeo = exports.User = exports.Telegram = exports.TikTok = exports.Spotify = exports.Soundcloud = exports.Linkedin = exports.AppleMusic = exports.NearBy = exports.LocationArrow = exports.SvgFlashOn = exports.SvgFlashOff = exports.SendPhoto = exports.QrOverlay = exports.PoweredBy = exports.WeChooseAuthentic = exports.GoogleColor = exports.Google = exports.Gear = exports.Youtube = exports.Tag = exports.Weibo = exports.Wechat = exports.X = exports.StoreOnline = exports.Store = exports.Spinner = exports.Search = exports.Plus = exports.Places = exports.Pinterest = exports.Pin = exports.Microphone = exports.MenuOpen = exports.Menu = exports.Lock = exports.Library = exports.Instagram = exports.Info = exports.Home = exports.Help = exports.FacebookColor = exports.Facebook = exports.Face5 = exports.Face4 = exports.Face3 = exports.Face2 = exports.Face1 = exports.EyeOpen = exports.EyeClose = exports.Exit = exports.Enter = exports.Email = exports.Edit = exports.Download = exports.DotsCircle = exports.DotsHorizontal = exports.Dots = exports.Document = exports.Distance = exports.CloseCircle = exports.Close = exports.ChevronRight = exports.ChevronLeft = exports.Check = exports.Calendar = exports.Camera = exports.Assistant = exports.Apple = void 0;

var _configuration = require("../../configuration");

var web = _interopRequireWildcard(require("./web"));

var _native = _interopRequireWildcard(require("./native"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _platformSwitch = (0, _configuration.platformSwitch)({
  web: web,
  "native": _native
}),
    Apple = _platformSwitch.Apple,
    Assistant = _platformSwitch.Assistant,
    Camera = _platformSwitch.Camera,
    Calendar = _platformSwitch.Calendar,
    Check = _platformSwitch.Check,
    ChevronLeft = _platformSwitch.ChevronLeft,
    ChevronRight = _platformSwitch.ChevronRight,
    Close = _platformSwitch.Close,
    CloseCircle = _platformSwitch.CloseCircle,
    Distance = _platformSwitch.Distance,
    Document = _platformSwitch.Document,
    Dots = _platformSwitch.Dots,
    DotsHorizontal = _platformSwitch.DotsHorizontal,
    DotsCircle = _platformSwitch.DotsCircle,
    Download = _platformSwitch.Download,
    Edit = _platformSwitch.Edit,
    Email = _platformSwitch.Email,
    Enter = _platformSwitch.Enter,
    Exit = _platformSwitch.Exit,
    EyeClose = _platformSwitch.EyeClose,
    EyeOpen = _platformSwitch.EyeOpen,
    Face1 = _platformSwitch.Face1,
    Face2 = _platformSwitch.Face2,
    Face3 = _platformSwitch.Face3,
    Face4 = _platformSwitch.Face4,
    Face5 = _platformSwitch.Face5,
    Facebook = _platformSwitch.Facebook,
    FacebookColor = _platformSwitch.FacebookColor,
    Help = _platformSwitch.Help,
    Home = _platformSwitch.Home,
    Info = _platformSwitch.Info,
    Instagram = _platformSwitch.Instagram,
    Library = _platformSwitch.Library,
    Lock = _platformSwitch.Lock,
    Menu = _platformSwitch.Menu,
    MenuOpen = _platformSwitch.MenuOpen,
    Microphone = _platformSwitch.Microphone,
    Pin = _platformSwitch.Pin,
    Pinterest = _platformSwitch.Pinterest,
    Places = _platformSwitch.Places,
    Plus = _platformSwitch.Plus,
    Search = _platformSwitch.Search,
    Spinner = _platformSwitch.Spinner,
    Store = _platformSwitch.Store,
    StoreOnline = _platformSwitch.StoreOnline,
    X = _platformSwitch.X,
    Wechat = _platformSwitch.Wechat,
    Weibo = _platformSwitch.Weibo,
    Tag = _platformSwitch.Tag,
    Youtube = _platformSwitch.Youtube,
    Gear = _platformSwitch.Gear,
    Google = _platformSwitch.Google,
    GoogleColor = _platformSwitch.GoogleColor,
    WeChooseAuthentic = _platformSwitch.WeChooseAuthentic,
    PoweredBy = _platformSwitch.PoweredBy,
    QrOverlay = _platformSwitch.QrOverlay,
    SendPhoto = _platformSwitch.SendPhoto,
    SvgFlashOff = _platformSwitch.SvgFlashOff,
    SvgFlashOn = _platformSwitch.SvgFlashOn,
    LocationArrow = _platformSwitch.LocationArrow,
    NearBy = _platformSwitch.NearBy,
    AppleMusic = _platformSwitch.AppleMusic,
    Linkedin = _platformSwitch.Linkedin,
    Soundcloud = _platformSwitch.Soundcloud,
    Spotify = _platformSwitch.Spotify,
    TikTok = _platformSwitch.TikTok,
    Telegram = _platformSwitch.Telegram,
    User = _platformSwitch.User,
    Vimeo = _platformSwitch.Vimeo,
    Vk = _platformSwitch.Vk,
    Whatsapp = _platformSwitch.Whatsapp,
    Red = _platformSwitch.Red;

exports.Red = Red;
exports.Whatsapp = Whatsapp;
exports.Vk = Vk;
exports.Vimeo = Vimeo;
exports.User = User;
exports.Telegram = Telegram;
exports.TikTok = TikTok;
exports.Spotify = Spotify;
exports.Soundcloud = Soundcloud;
exports.Linkedin = Linkedin;
exports.AppleMusic = AppleMusic;
exports.NearBy = NearBy;
exports.LocationArrow = LocationArrow;
exports.SvgFlashOn = SvgFlashOn;
exports.SvgFlashOff = SvgFlashOff;
exports.SendPhoto = SendPhoto;
exports.QrOverlay = QrOverlay;
exports.PoweredBy = PoweredBy;
exports.WeChooseAuthentic = WeChooseAuthentic;
exports.GoogleColor = GoogleColor;
exports.Google = Google;
exports.Gear = Gear;
exports.Youtube = Youtube;
exports.Tag = Tag;
exports.Weibo = Weibo;
exports.Wechat = Wechat;
exports.X = X;
exports.StoreOnline = StoreOnline;
exports.Store = Store;
exports.Spinner = Spinner;
exports.Search = Search;
exports.Plus = Plus;
exports.Places = Places;
exports.Pinterest = Pinterest;
exports.Pin = Pin;
exports.Microphone = Microphone;
exports.MenuOpen = MenuOpen;
exports.Menu = Menu;
exports.Lock = Lock;
exports.Library = Library;
exports.Instagram = Instagram;
exports.Info = Info;
exports.Home = Home;
exports.Help = Help;
exports.FacebookColor = FacebookColor;
exports.Facebook = Facebook;
exports.Face5 = Face5;
exports.Face4 = Face4;
exports.Face3 = Face3;
exports.Face2 = Face2;
exports.Face1 = Face1;
exports.EyeOpen = EyeOpen;
exports.EyeClose = EyeClose;
exports.Exit = Exit;
exports.Enter = Enter;
exports.Email = Email;
exports.Edit = Edit;
exports.Download = Download;
exports.DotsCircle = DotsCircle;
exports.DotsHorizontal = DotsHorizontal;
exports.Dots = Dots;
exports.Document = Document;
exports.Distance = Distance;
exports.CloseCircle = CloseCircle;
exports.Close = Close;
exports.ChevronRight = ChevronRight;
exports.ChevronLeft = ChevronLeft;
exports.Check = Check;
exports.Calendar = Calendar;
exports.Camera = Camera;
exports.Assistant = Assistant;
exports.Apple = Apple;